import { newId } from "../utils/dataTypesUtils"
import { Settings, SettingsModule } from "../../../modules/administration"

export const settings = (companyId: string): Settings[] => [
    { companyId, id: newId(), module: SettingsModule.PURCHASES, generalSaleYield: 10 },
    { companyId, id: newId(), module: SettingsModule.SALES }
]
